/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Footer',
        import: () => import(/* webpackChunkName: "Footer" */ '@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'Header',
        import: () => import(/* webpackChunkName: "Header" */ '@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Notification',
        import: () => import(/* webpackChunkName: "Notification" */ '@stories/Widgets/Global/Notification/Notification'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'RichText',
        import: () => import(/* webpackChunkName: "RichText" */ '@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'HeroCarouselBanner',
        import: () => import(/* webpackChunkName: "HeroCarouselBanner" */ '@stories/Widgets/HeroCarouselBanner/HeroCarouselBanner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ImmersiveBanner',
        import: () => import(/* webpackChunkName: "HeroCarouselBanner" */ '@stories/Widgets/ImmersiveBanner/ImmersiveBanner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'BasicHeroBanner',
        import: () => import(/* webpackChunkName: "BasicHeroBanner" */ '@stories/Widgets/BasicHeroBanner/BasicHeroBanner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'AccordionList',
        import: () => import(/* webpackChunkName: "AccordionList" */ '@stories/Widgets/AccordionList/AccordionList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ButtonGroup',
        import: () => import(/* webpackChunkName: "ButtonGroup" */ '@stories/Widgets/ButtonGroup/ButtonGroup'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'NavigationBlock',
        import: () => import(/* webpackChunkName: "NavigationBlock" */ '@stories/Widgets/NavigationBlock/NavigationBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'LinkBlock',
        import: () => import(/* webpackChunkName: "LinkBlock" */ '@stories/Widgets/LinkBlock/LinkBlock'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'CtaBlockLink',
        import: () => import(/* webpackChunkName: "CtaBlockLink" */ '@stories/Widgets/CtaBlockLink/CtaBlockLink'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'PeopleCarousel',
        import: () => import(/* webpackChunkName: "PeopleCarousel" */ '@stories/Widgets/PeopleCarousel/PeopleCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeedFilters',
        import: () => import(/* webpackChunkName: "FeedFilters" */ '@stories/Widgets/FeedFilters/FeedFilters'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SimpleCarousel',
        import: () => import(/* webpackChunkName: "SimpleCarousel" */ '@stories/Widgets/SimpleCarousel/SimpleCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SectionHeader',
        import: () => import(/* webpackChunkName: "SectionHeader" */ '@stories/Widgets/SectionHeader/SectionHeader'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'VideoComponent',
        import: () => import(/* webpackChunkName: "VideoComponent" */ '@stories/Widgets/VideoComponent/VideoComponent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ListCardCarousel',
        import: () => import(/* webpackChunkName: "ListCardCarousel" */ '@stories/Widgets/ListCardCarousel/ListCardCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TeamsListing',
        import: () => import(/* webpackChunkName: "TeamsListing" */ '@stories/Widgets/TeamsListing/TeamsListing'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'ImageComponent',
        import: () => import(/* webpackChunkName: "ImageComponent" */ '@stories/Widgets/ImageComponent/ImageComponent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TabbedContent',
        import: () => import(/* webpackChunkName: "TabbedContent" */ '@stories/Widgets/TabbedContent/TabbedContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InsightsSection',
        import: () => import(/* webpackChunkName: "InsightsSection" */ '@stories/Widgets/InsightsSection/InsightsSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'QuoteSection',
        import: () => import(/* webpackChunkName: "QuoteSection" */ '@stories/Widgets/QuoteSection/QuoteSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'LatestFeed',
        import: () => import(/* webpackChunkName: "LatestFeed" */ '@stories/Widgets/LatestFeed/LatestFeed'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NoticeSearch',
        import: () => import(/* webpackChunkName: "NoticeSearch" */ '@stories/Widgets/NoticeSearch/NoticeSearch'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FilteredCardListing',
        import: () => import(/* webpackChunkName: "FilteredCardListing" */ '@stories/Widgets/FilteredCardListing/FilteredCardListing'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'SectorsServicesList',
        import: () => import(/* webpackChunkName: "SectorsServicesList" */ '@stories/Widgets/SectorsServicesList/SectorsServicesList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StandstillCalculator',
        import: () => import(/* webpackChunkName: "StandstillCalculator" */ '@stories/Widgets/StandstillCalculator/StandstillCalculator'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ModalContactForm',
        import: () => import(/* webpackChunkName: "ModalContactForm" */ '@stories/Widgets/ModalContactForm/ModalContactForm'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeedCard',
        import: () => import(/* webpackChunkName: "FeedCard" */ '@stories/Components/Cards/FeedCard/FeedCard'),
        config: {
            hydrate: 'in-view',
        },
    },
];
